import { PollType, PollTypeCode } from '@/types/poll'

interface PollItem {
  id: number
  name: string
  code: PollTypeCode
}

const pollTypeItems: PollItem[] = [
  {
    id: PollType.SIMPLE,
    name: 'Обычный',
    code: PollTypeCode.SIMPLE,
  },
  {
    id: PollType.TWO_OPTIONS,
    name: 'Два варианта',
    code: PollTypeCode.TWO_OPTIONS,
  },
  {
    id: PollType.ARTICLES,
    name: 'Статьи',
    code: PollTypeCode.ARTICLES,
  },
]

const pollTypeMap = new Map<number | PollTypeCode, PollItem>()

pollTypeItems.forEach((item) => {
  pollTypeMap.set(item.id, item)
  pollTypeMap.set(item.code, item)
})

export { pollTypeItems, pollTypeMap }
